<template>
  <div class="page-footer">
    <div class="hotel-list" v-if="list.length">
      <div
        class="hotel-item"
        v-for="item in list"
        :class="{ 'active': pano_id == item.pano_id }"
        :key="item.id"
        @click="select(item)"
      >
        <div class="cover-warp">
          <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }">
            <!-- <img src="../images/icon_360.png" class="icon" /> -->
          </div>
          <div v-if="priceVisible && item.min_price > 1" class="is-pay">付费</div>
        </div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div class="blank-wrap" v-else>
      <span>暂无其他方案</span>
    </div>
  </div>
</template>

<script>
import qs from "@halobear/utils/qs";


export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    pano_id: {
      type: [String, Number],
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    priceVisible() {
      const route = this.$route;
      const query = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "");
      return !query.phone;
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    select(item) {
      this.close();
      this.$emit("select", item.pano_id);
    },
  },
};
</script>

<style lang="less" scoped>
.page-footer {
  width: 750px;
  height: 196px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.hotel-list {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
  .hotel-item {
    position: relative;
    width: 124px;
    text-align: center;
    margin-right: 20px;
    &:first-child {
      margin-left: 40px;
    }
    &:last-child {
      margin-right: 40px;
    }
    &.active {
      .cover-warp {
        border: 2px solid #fff;
      }
      .title {
        opacity: 1.0;
      }
    }
  }
  .cover-warp {
    width: 126px;
    height: 86px;
    padding: 2px 2px;
  }
  .cover {
    width: 120px;
    height: 80px;
    background-color: #eee;
    border-radius: 6px;
    position: relative;
    display: block;
  }
  .icon {
    width: 64px;
    height: 64px;
    position: absolute;
    left: 12px;
    bottom: 12px;
  }
  .title {
    color: #fff;
    font-size: 20px;
    line-height: 28px;
    margin-top: 8px;
    text-align: center;
    opacity: 0.6;
  }
  .is-pay {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 46px;
    height: 26px;
    background: #232323;
    border-radius: 6px 0 6px 0;
    font-size: 18px;
    line-height: 26px;
    color: #FDC3AD;
    text-align: center;
  }
}
.blank-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  font-size: 30px;
  padding: 80px 0;
  .blank-icon {
    width: 330px;
    height: 330px;
    object-fit: contain;
    object-position: center center;
    margin-bottom: 60px;
  }
}
</style>
